import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-payments',
  templateUrl: './track-payments.component.html',
  styleUrls: ['./track-payments.component.css']
})
export class TrackPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
